module.exports = __webpack_public_path__ + "static/img/douyinBeBa.f65050c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/client/logo/douyinBeBa.jpg
// module id = i1mz
// module chunks = 0